import './index.scss';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getOrganizationMetadata } from '~/redux/reducers/states/org_metadata';
import AppSidebar from './app_sidebar';
import { AppSidebarProvider, useAppSidebar } from './app_sidebar/provider';
import { MenuStates } from './app_sidebar/provider/enums';
import Header from './header';
const MainLayout = ({ children }) => {
    const dispatch = useDispatch();
    const { activeRoute, isCollapsed } = useAppSidebar();
    useEffect(() => {
        dispatch(getOrganizationMetadata());
    }, []);
    const contentClasses = classNames('content', {
        'with-sidebar': activeRoute.includes(MenuStates.ProjectsWorkspace) && !isCollapsed,
    });
    return (React.createElement("div", { className: 'app-container' },
        React.createElement(Header, null),
        React.createElement("div", { className: 'app-content' },
            React.createElement(AppSidebar, null),
            React.createElement("div", { className: contentClasses }, children))));
};
const MainLayoutWrapper = ({ children }) => {
    return React.createElement(AppSidebarProvider, null,
        React.createElement(MainLayout, null, children));
};
export default MainLayoutWrapper;
